import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import { removeNullFields } from "../../../common/mapper";
import { formGroup, tableColumns1 } from "../config";
import PenerimaanSSUDetail from "./penerimaanSSUDetail";
import PenerimaanSSUFilter from "./penerimaanSSUFilter";
import M from "moment/moment";
import Api from "../../../../Services/Api";
import ErrorAction from "../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { fetchDataAsync } from "../../../../Services/Utils";
import * as R from "ramda";

class PenerimaanSSUTable extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        setCellProps: () => ({
          style: {
            width: "5%",
          },
        }),
      },
    },
    ...tableColumns1,
    {
      name: "ssuStatus",
      label: "Aksi",
      options: {
        customBodyRender: (val, { rowIndex }) => (
          <SimpleButton
            category="action_button"
            className="btnAct"
            onClick={() => this.handleDetailVisibility(rowIndex)}
            icon={
              <i
                className="fa fa-lw fa-pencil-alt"
                style={{
                  backgroundColor: "transparent",
                  color: "red",
                  fontSize: 20,
                }}
              />
            }
          />
        ),
      },
    },
  ];

  constructor(props) {
    super(props);
    this.pagination = this.props.state.pagination;
    this.fakturInitialData = {
      fromTimeSalesFakturDate: null,
      toTimeSalesFakturDate: null,
      fromTimeSSUDate: null,
      toTimeSSUDate: null,
      fromTimeReceivedSSUDate: null,
      toTimeReceivedSSUDate: null,
    };
    this.state = {
      detailData: null,
      selectedId: null,
      selectedData: {},
      detailVisible: false,
      filterVisible: false,
      salesOrderState: null,
      filterData: {
        ...this.fakturInitialData,
        // variant: [{label: "ALL", value: "ALL"}],
        // warna: [{label: "ALL", value: "ALL"}],
        variant: [],
        warna: [],
      },
    };
  }

  handleDetailVisibility = async (index) => {
    this.props.triggerLoading();
    if (index >= 0) {
      const selectedId = this.props.state.dataTable[index].ssuId;
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getSSUById,
        setError: this.props.setError,
        menuName: "Proses SSU - Penerimaan SSU",
        args: selectedId,
      });
      if (response.ok) {
        let data = response.data.data;
        this.setState((prevValue) => ({
          ...prevValue,
          selectedData: {
            ...data,
            kodeVariant: this.props.state.variantOptions.find((kv) =>
              R.equals(kv.value, data.kodeVariant)
            ),
            kodeWarna: this.props.state.warnaOptions.find((kw) =>
              R.equals(kw.value, data.kodeWarna)
            ),
            stnkName: {
              name: data.dataCustomerOwner.dataCustomer.customerName,
              customerId: data.dataCustomerOwner.customerId,
            },
            customerName: {
              name: data.dataCustomer.dataCustomer.customerName,
              customerId: data.dataCustomer.customerId,
            },
          },
          detailVisible: !prevValue.detailVisible,
          salesOrderState: data.salesOrderState,
        }));
      }
      this.props.triggerLoading();
      return;
    }

    this.setState((prevValue) => ({
      ...prevValue,
      selectedId: null,
      detailVisible: !prevValue.detailVisible,
      salesOrderState: null,
    }));
    this.props.triggerLoading();
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleOnSubmitSSU = (data) => {
    const { page, limit } = this.props.state.pagination;
    data = {
      ...data,
      kodeVariant: data.kodeVariant.value,
      kodeWarna: data.kodeWarna.value,
      recipientName: this.props.user.name,
      kodeCabang: this.props.state.search.kodeCabang.value,
      receivedSSUDate: M(new Date()).format("DD-MM-yyyy"),
      customerOwnerId: data.stnkName.customerId,
      customerId: data.customerName.customerId,
      ssuStatus: R.equals(data.ssuStatus, "BATAL") ? "BATAL" : "SELESAI",
    };
    let { stnkName, customerName, ...request } = data;
    this.handleDetailVisibility();
    this.props.onSubmitSSU({
      ...request,
      __pagination: { page, limit }, 
    });
  };

  handleSubmitFilter = (e) => {
    let { warnaRaw, variantOptions } = this.props.state;
    e.preventDefault();
     let filterData = { ...this.state.filterData };

    if (Array.isArray(filterData.variant) && filterData.variant.length === 0) {
      filterData.variant = [{ label: "ALL", value: "ALL" }];
    }
    if (Array.isArray(filterData.warna) && filterData.warna.length === 0) {
      filterData.warna = [{ label: "ALL", value: "ALL" }];
    }
    
    let request = removeNullFields({ ...filterData });
       let variant = request.variant
         ? request.variant.some((v) => v.value === "ALL")
           ? variantOptions.map((v) => v.value).filter((v) => v !== "ALL")
           : request.variant.map((v) => v.value)
         : null;
   
    let warna =
         R.isNil(variant) || R.isEmpty(variant)
           ? null
           : request.warna
           ? request.warna.some((w) => w.value === "ALL")
             ? warnaRaw
                 .filter((w) => variant.includes(w.kodeVariant))
                 .map((w) => w.id)
             : request.warna.map((w) => w.value)
           : null;
    request = {
      ...request,
      warna,
      variant,
      fromTimeSalesFakturDate: request.fromTimeSalesFakturDate
        ? M(request.fromTimeSalesFakturDate).format("DD-MM-yyyy")
        : null,
      toTimeSalesFakturDate: request.toTimeSalesFakturDate
        ? M(request.toTimeSalesFakturDate).format("DD-MM-yyyy")
        : null,
      fromTimeSSUDate: request.fromTimeSSUDate
        ? M(request.fromTimeSSUDate).format("DD-MM-yyyy")
        : null,
      toTimeSSUDate: request.toTimeSSUDate
        ? M(request.toTimeSSUDate).format("DD-MM-yyyy")
        : null,
      fromTimeReceivedSSUDate: request.fromTimeReceivedSSUDate
        ? M(request.fromTimeReceivedSSUDate).format("DD-MM-yyyy")
        : null,
      toTimeReceivedSSUDate: request.toTimeReceivedSSUDate
        ? M(request.toTimeReceivedSSUDate).format("DD-MM-yyyy")
        : null,
    };
    request = removeNullFields({ ...request });
    this.handleFilterVisibility();
    this.props.onSubmitFilter(request);
  };

  handleResetFilter = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...this.fakturInitialData,
      },
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  render() {
    return (
      <>
        <FlexView hAlignContent="right">
          <SimpleButton
            className="btn background-red margin-bottom-15px"
            category="action_button"
            icon={<i className="fa fa-qrcode"></i>}
            onClick={this.handleFilterVisibility}
          />
        </FlexView>
        <SimpleDataTable
          data={this.props.state.dataTable}
          columns={this.tableColumns}
          toCount={this.props.state.pagination.totalData}
          rowsPerPage={this.props.state.pagination.limit}
          page={this.props.state.pagination.page - 1}
          options={defaultTableChange(
            this.props.onChangePage,
            this.props.onChangeRowsPerPage
          )}
        />
        {this.state.filterVisible && (
          <PenerimaanSSUFilter
            state={this.state}
            options={{
              warnaOptions: this.props.state.warnaOptions,
              variantOptions: this.props.state.variantOptions,
              warnaRaw: this.props.state.warnaRaw,
            }}
            onClickClose={this.handleFilterVisibility}
            onReset={this.handleResetFilter}
            onChange={this.handleValueChange}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {this.state.detailVisible && (
          <PenerimaanSSUDetail
            formGroup={formGroup}
            state={this.state}
            initialValues={this.state.selectedData}
            options={{
              warnaOptions: this.props.state.warnaOptions,
              variantOptions: this.props.state.variantOptions,
            }}
            salesOrderState={this.state.salesOrderState}
            onClickClose={() => this.handleDetailVisibility()}
            onSubmit={this.handleOnSubmitSSU}
          />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(PenerimaanSSUTable);
